module.exports = __webpack_public_path__ + "static/media/valpo-5.a6b5a695.jpg";